import { useEffect, useState } from "react";

// Original Revelate logo choreography, extracted from the preserved App.js.
const TITLE_DELAYS = [0.4, 0.0, 0.25, 0.55, 0.1, 0.35, 0.15, 0.5];
const WORD_SWEEP_DELAYS = [0, 0, 0, 0, 0, 0.12, 0.24, 0.36];
export const REVELATE_DIALOGUE_MESSAGES = [
  "Letters become words. You choose the moment.",
  "A word, waiting to be revealed.",
  "Reveal the word. Make room for more.",
];
export const DIALOGUE_HOLD_MS = 3200;
const DIALOGUE_FADE_MS = 320;

export function RevelateDialogue() {
  const [messageIndex, setMessageIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    let stopped = false;
    const ids = [];
    function scheduleNext() {
      ids.push(setTimeout(() => {
        if (stopped) return;
        setVisible(false);
        ids.push(setTimeout(() => {
          if (stopped) return;
          setMessageIndex(index => (index + 1) % REVELATE_DIALOGUE_MESSAGES.length);
          setVisible(true);
          scheduleNext();
        }, DIALOGUE_FADE_MS));
      }, DIALOGUE_FADE_MS + DIALOGUE_HOLD_MS));
    }

    scheduleNext();
    return () => { stopped = true; ids.forEach(clearTimeout); };
  }, []);

  return <div className={`logo-loop-caption ${visible ? "dialogue-visible" : "dialogue-clearing"}`} aria-live="polite" aria-atomic="true">
    <span>{REVELATE_DIALOGUE_MESSAGES[messageIndex]}</span>
  </div>;
}

export default function RevelateLogo({ animated = false, compact = false }) {
  const [phase, setPhase] = useState(animated ? "idle" : "settle");
  useEffect(() => {
    if (!animated) return;
    let stopped = false;
    const ids = [];
    const delay = ms => new Promise(resolve => ids.push(setTimeout(() => { if (!stopped) resolve(); }, ms)));
    async function run() {
      setPhase("idle");
      await delay(1000);
      if (stopped) return;
      setPhase("settle");
      while (!stopped) {
        await delay(1400); if (stopped) return; setPhase("highlight");
        await delay(1450); if (stopped) return; setPhase("clear");
        await delay(440); if (stopped) return; setPhase("restore");
        await delay(640); if (stopped) return; setPhase("settle");
        await delay(2200); if (stopped) return;
      }
    }
    run();
    return () => { stopped = true; ids.forEach(clearTimeout); };
  }, [animated]);

  return <div className={`revelate-logo ${compact ? "logo-compact" : "logo-home"}`} data-phase={phase} role="img" aria-label={animated ? "Revelate. Letters form the name, the word LATE is revealed, and the letters return to build again." : "Revelate"}>
    <div className="logo-tiles" aria-hidden="true">{"REVELATE".split("").map((letter, i) => {
      const word = i >= 4;
      let animation = "none";
      if (animated && phase === "idle") animation = `logo-fall .38s ease-out ${TITLE_DELAYS[i]}s both`;
      if (animated && word && phase === "highlight") animation = `logo-highlight .24s ease-out ${WORD_SWEEP_DELAYS[i]}s both`;
      if (animated && word && phase === "clear") animation = "logo-clear .5s ease-in both";
      if (animated && word && phase === "restore") animation = "logo-restore .6s ease-out both";
      return <span key={i} className={`logo-tile ${word ? "logo-word" : ""}`} style={{ animation }}>{letter}</span>;
    })}</div>
  </div>;
}
